<template>
    <div>
        <el-dialog
            class="open-vip-dialog"
            close-on-click-modal
            :model-value="topUpState"
            :destroy-on-close="true"
            @close="close"
            draggable
            align-center
            width="680"
        >
            <template #header>
                <div class="open-vip-header">
<!--                    <div class="open-vip-badge">{{ sceneLabel }}</div>-->
                    <div class="open-vip-title">{{ dialogConfig.dialogTitle }}</div>
<!--                    <div class="open-vip-subtitle">选择套餐后使用微信扫码支付，支付完成后关闭弹窗即可</div>-->
                </div>
            </template>

            <div class="open-vip-body">
                <section v-if="dialogConfig.noticeList.length" class="open-vip-notice-panel">
                    <div class="open-vip-section-head">
                        <div class="open-vip-section-title">
                            <span class="open-vip-section-dot"></span>
                            <span>{{ dialogConfig.noticeTitle }}</span>
                        </div>
                    </div>
                    <div class="open-vip-notice-list">
                        <div
                            v-for="(item, index) in dialogConfig.noticeList"
                            :key="index"
                            class="open-vip-notice-item"
                        >
                         <span :style="{ color: item.color || '#475569' }">
                            <template v-if="!item.noIndex">
                              {{ index + 1 }}.
                            </template>
                            {{ item.text || item }}
                          </span>
                        </div>
                    </div>
                </section>

                <section class="open-vip-panel">
                    <div class="open-vip-section-head">
                        <div class="open-vip-section-title">
                            <span class="open-vip-section-dot"></span>
                            <span>{{ dialogConfig.packageTitle }}</span>
                        </div>
                        <div v-if="selectedPackageName" class="open-vip-section-tip">已选：{{ selectedPackageName }}</div>
                    </div>

                    <el-radio-group class="open-vip-package-grid" v-model="checkAmount" @change="radioChange">
                        <template v-if="topUpList.length">
                            <el-radio
                                v-for="(item, index) in topUpList"
                                :key="index"
                                border
                                class="open-vip-package-card"
                                :value="item.id"
                            >
                                <span class="open-vip-package-name">{{ item.name }}</span>
                            </el-radio>
                        </template>
                        <div v-else class="open-vip-empty">暂无可选套餐</div>
                    </el-radio-group>
                </section>

                <section class="open-vip-qr-panel">
                    <div class="open-vip-section-head">
                        <div class="open-vip-section-title">
                            <span class="open-vip-section-dot"></span>
                            <span>扫码支付</span>
                        </div>
                        <div class="open-vip-section-tip">微信扫码支付</div>
                    </div>

                    <div v-if="qrCodeInfo" class="open-vip-qr-box">
                        <QrcodeVue :value="qrCodeInfo" :size="188" level="H"></QrcodeVue>
                    </div>
                    <div v-else class="open-vip-qr-placeholder">请选择套餐后生成二维码</div>

                    <div class="open-vip-footer-tip">
                        {{ dialogConfig.successTitle }}
                    </div>
                </section>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: "openVip",
        components: {
            QrcodeVue,
        },
        data() {
            return {
                topUpState: false,
                qrCodeInfo: '',
                topUpList: [],
                checkAmount: null,
                dialogConfig: this.getDefaultConfig(),
            }
        },
        computed: {
            sceneLabel() {
                return this.getSceneConfig(Number(this.dialogConfig.businessType)).badgeLabel
            },

            selectedPackageName() {
                const current = this.topUpList.find(item => String(item.id) === String(this.checkAmount))
                return current ? current.name : ''
            }
        },
        methods: {
            getSceneConfig(businessType) {
                const sceneMap = {
                    0: {
                        badgeLabel: '账户充值',
                        dialogTitle: '钱包充值-套餐选择',
                        packageTitle: '选择套餐',
                        successTitle: '支付完成后，请关闭此窗口',
                        noticeTitle: '充值须知',
                        noticeList: [
                          '钱包充值为虚拟金额服务，支付成功后余额即时到账，不支持退款或提现。',
                          '充值余额仅限当前账号使用，不可转移、转赠或兑换现金。',
                          '支付完成即视为同意上述说明，请确认充值金额及充值门店后再进行充值。'
                        ],
                        reloadOnClose: false,
                    },

                    1: {
                        badgeLabel: 'VIP 服务',
                        dialogTitle: 'VIP-套餐选择',
                        packageTitle: '选择套餐',
                        successTitle: '支付完成后，请关闭此窗口',
                        noticeTitle: '购买须知',
                        noticeList: [
                            'VIP充值服务为虚拟产品，支付成功后即时到账，不支持退款。',
                            'VIP权益不可转移至其他账号，剩余时长无法折算现金或转赠。',
                            '支付即视为同意上述说明，请确认需求后再进行购买。'
                        ],
                        reloadOnClose: false,
                    },
                    2: {
                        badgeLabel: '投屏续费',
                        dialogTitle: '场次投屏-套餐选择',
                        packageTitle: '选择套餐',
                        successTitle: '支付完成后，请关闭此窗口',
                        noticeTitle: '购买须知',
                        noticeList: [
                          '投屏续费服务属于虚拟服务，支付成功后将即时生效，不支持退款。',
                          '投屏权益仅限当前门店使用，不可转移至其他门店或账号，剩余时长不支持折现或转赠。',
                          '请确认当前门店与续费需求无误后再支付，完成支付即视为同意上述说明。',
                          {
                            text: '*新用户开通需前往微信密室玩乐小程序，去配件商城搜索场次投屏智能盒，添加购物车结算下单，并联系管家顾问君君！',
                            color: '#ef4444',
                            noIndex: true
                          }
                        ],
                        reloadOnClose: false,
                    }
                }
                return sceneMap[businessType] || sceneMap[1]
            },

            getDefaultConfig() {
                const sceneConfig = this.getSceneConfig(1)
                return {
                    businessType: 1,
                    qrCodeType: 1,
                    dialogTitle: sceneConfig.dialogTitle,
                    packageTitle: sceneConfig.packageTitle,
                    successTitle: sceneConfig.successTitle,
                    noticeTitle: sceneConfig.noticeTitle,
                    noticeList: sceneConfig.noticeList,
                    reloadOnClose: sceneConfig.reloadOnClose,
                    autoOpen: false,
                    onClose: null,
                    shopId: this.$store.state.shopInfo.id,
                    companyId: this.$store.state.companyInfo.companyId,
                }
            },

            normalizeConfig(options = {}) {
                const businessType = typeof options.businessType === 'undefined' ? 1 : Number(options.businessType)
                const sceneConfig = this.getSceneConfig(businessType)
                const defaultConfig = {
                    businessType,
                    qrCodeType: businessType,
                    dialogTitle: sceneConfig.dialogTitle,
                    packageTitle: sceneConfig.packageTitle,
                    successTitle: sceneConfig.successTitle,
                    noticeTitle: sceneConfig.noticeTitle,
                    noticeList: sceneConfig.noticeList,
                    reloadOnClose: sceneConfig.reloadOnClose,
                    autoOpen: false,
                    onClose: null,
                    shopId: this.$store.state.shopInfo.id,
                    companyId: this.$store.state.companyInfo.companyId,
                }
                return {
                    ...defaultConfig,
                    ...options,
                    businessType,
                    noticeTitle: options.noticeTitle || defaultConfig.noticeTitle,
                    noticeList: Array.isArray(options.noticeList) ? options.noticeList : defaultConfig.noticeList,
                    qrCodeType: typeof options.qrCodeType === 'undefined' ? businessType : Number(options.qrCodeType),
                }
            },

            buildQrCode(packageId) {
                return 'https://jxkj1987.cn/staticfile/wxQRcodeFile/pay/shopid=' +
                    this.dialogConfig.shopId + '&companyid=' + this.dialogConfig.companyId +
                    '&id=' + packageId + '&type=' + this.dialogConfig.qrCodeType
            },

            setDefaultPackage() {
                if (this.topUpList && this.topUpList.length > 0) {
                    this.checkAmount = this.topUpList[0].id
                    this.qrCodeInfo = this.buildQrCode(this.topUpList[0].id)
                } else {
                    this.checkAmount = null
                    this.qrCodeInfo = ''
                }
            },

            radioChange(value) {
                this.qrCodeInfo = this.buildQrCode(value)
            },

            close() {
                this.topUpState = false
                if (typeof this.dialogConfig.onClose === 'function') {
                    this.dialogConfig.onClose()
                }
            },

            initData(options = {}) {
                this.dialogConfig = this.normalizeConfig(options)
                this.topUpList = []
                this.checkAmount = null
                this.qrCodeInfo = ''
                this.$POST("/customer/EomsOssSpacePackagesConfig/config/page", {
                    shopId: this.dialogConfig.shopId,
                    businessType: this.dialogConfig.businessType
                }).then(res => {
                    this.topUpList = res.data.records || []
                    this.setDefaultPackage()
                    this.topUpState = true
                })
            },
        },
    }
</script>

<style>
    .open-vip-dialog {
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 0 28px 80px rgba(15, 23, 42, 0.24);
    }

    .open-vip-dialog .el-dialog__header {
        margin-right: 0;
        padding: 0;
        border-bottom: none;
        background:
            radial-gradient(circle at top left, rgba(59, 130, 246, 0.2), transparent 34%),
            linear-gradient(135deg, #f7faff 0%, #eef5ff 100%);
    }

    .open-vip-dialog .el-dialog__body {
        padding: 16px 18px 18px;
        background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
    }

    .open-vip-dialog .el-dialog__headerbtn {
        top: 18px;
        right: 18px;
        width: 34px;
        height: 34px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.84);
        transition: all 0.2s ease;
    }

    .open-vip-dialog .el-dialog__headerbtn:hover {
        background: #ffffff;
        transform: rotate(90deg);
    }

    .open-vip-dialog .el-dialog__headerbtn .el-dialog__close {
        margin: 0;
        font-size: 16px;
        line-height: 1;
    }

    .open-vip-header {
        padding: 10px 22px 16px 20px;
    }

    .open-vip-badge {
        display: inline-flex;
        align-items: center;
        height: 28px;
        padding: 0 12px;
        border: 1px solid rgba(96, 165, 250, 0.35);
        border-radius: 999px;
        color: #2563eb;
        background: rgba(255, 255, 255, 0.9);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.4px;
    }

    .open-vip-title {
        margin-top: 12px;
        color: #0f172a;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.3;
    }

    .open-vip-subtitle {
        margin-top: 8px;
        color: #64748b;
        font-size: 13px;
        line-height: 1.6;
    }

    .open-vip-body {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 236px;
        gap: 14px;
        align-items: start;
    }

    .open-vip-panel,
    .open-vip-qr-panel,
    .open-vip-notice-panel {
        padding: 14px;
        border: 1px solid #e7eef8;
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.96);
        box-shadow: 0 16px 40px rgba(148, 163, 184, 0.12);
    }

    .open-vip-qr-panel {
        grid-column: 2;
        grid-row: 1 / span 2;
    }

    .open-vip-section-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 12px;
    }

    .open-vip-section-title {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #0f172a;
        font-size: 15px;
        font-weight: 700;
    }

    .open-vip-section-dot {
        width: 8px;
        height: 8px;
        border-radius: 999px;
        background: linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%);
        box-shadow: 0 0 0 6px rgba(59, 130, 246, 0.12);
    }

    .open-vip-section-tip {
        color: #64748b;
        font-size: 12px;
        font-weight: 600;
    }

    .open-vip-package-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    }

    .open-vip-package-grid .el-radio {
        margin-right: 0;
    }

    .open-vip-package-card {
        flex: 1 1 calc(50% - 6px);
        min-width: 160px;
        height: 48px;
        margin-left: 0;
        padding: 0 14px;
        border: 1px solid #d9e3f0;
        border-radius: 16px;
        background: #ffffff;
        transition: all 0.2s ease;
    }

    .open-vip-package-card:hover {
        border-color: #93c5fd;
        background: #f8fbff;
        transform: translateY(-1px);
    }

    .open-vip-package-card.is-bordered.is-checked {
        border-color: #60a5fa;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(14, 165, 233, 0.08));
        box-shadow: 0 12px 28px rgba(59, 130, 246, 0.14);
    }

    .open-vip-package-name {
        color: #334155;
        font-weight: 600;
    }

    .open-vip-package-card .el-radio__input.is-checked + .el-radio__label .open-vip-package-name {
        color: #1d4ed8;
    }

    .open-vip-empty {
        width: 100%;
        padding: 22px 16px;
        border: 1px dashed #d6e0ee;
        border-radius: 16px;
        color: #94a3b8;
        text-align: center;
        font-size: 13px;
    }

    .open-vip-qr-box,
    .open-vip-qr-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 220px;
        border-radius: 16px;
        background:
            linear-gradient(135deg, rgba(59, 130, 246, 0.06), rgba(14, 165, 233, 0.03)),
            #ffffff;
        border: 1px solid #dbe7f5;
    }

    .open-vip-qr-box canvas {
        border-radius: 12px;
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    }

    .open-vip-qr-placeholder {
        color: #94a3b8;
        font-size: 13px;
        font-weight: 600;
    }

    .open-vip-footer-tip {
        margin-top: 10px;
        color: #64748b;
        font-size: 12px;
        line-height: 1.5;
        text-align: center;
    }

    .open-vip-notice-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: #475569;
        font-size: 12px;
        line-height: 1.6;
    }

    .open-vip-notice-item {
        padding-left: 2px;
    }

    @media (max-width: 768px) {
        .open-vip-dialog {
            width: calc(100vw - 24px) !important;
            margin-top: 5vh !important;
        }

        .open-vip-header {
            padding: 20px 18px 16px;
        }

        .open-vip-dialog .el-dialog__body {
            padding: 16px 16px 20px;
        }

        .open-vip-title {
            font-size: 20px;
        }

        .open-vip-body {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .open-vip-qr-panel {
            grid-column: auto;
            grid-row: auto;
        }

        .open-vip-package-card {
            min-width: 100%;
            flex-basis: 100%;
        }

        .open-vip-qr-box,
        .open-vip-qr-placeholder {
            min-height: 232px;
        }
    }
</style>
